// The pill a duty type is shown in, where it can only be read.
//
// Started life inline on the Payment Collections table; the client asked for the
// same treatment on the Client List and Current Client List, so it lives here
// and all of them render the identical thing.
//
// Coloured from the shared duty palette — the same blue/violet/teal the
// operations board uses — so a duty type looks the same wherever it appears,
// including next to the editable DutyTypeSelect on Current Payment Collections.
//
// No whiteSpace:nowrap on purpose — the long duty types ("Medical Equipment")
// wrap inside the pill rather than spilling out of a narrow column.

import React from 'react';
import { dutyPalette } from '../constants/shifts';

const DutyTypePill: React.FC<{ dutyType?: string | null }> = ({ dutyType }) => {
  if (!dutyType) return <>—</>;
  const pal = dutyPalette(dutyType);
  return (
    <span
      style={{
        display: 'inline-block', padding: '2px 8px', borderRadius: '9999px',
        fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.02em',
        backgroundColor: pal.bg, color: pal.fg, border: `1.5px solid ${pal.border}`,
      }}
    >
      {dutyType}
    </span>
  );
};

export default DutyTypePill;
